export default function ProficiencyCard() {
    return (
        <div className="border rounded-lg overflow-hidden">
            <div className="flex items-center gap-2 p-4 border-b">
                <div className="bg-purple-100 p-1 rounded">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-purple-500"
                    >
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                </div>
                <h3 className="font-medium">English Proficiency</h3>
            </div>

            <div className="p-4 bg-gray-50">
                <div className="flex justify-between items-center mb-4">
                    <div className="bg-purple-100 text-purple-800 font-bold text-xl px-3 py-1 rounded">
                        B2
                    </div>
                    <div className="text-gray-500 text-sm">Intermediate</div>
                </div>

                <p className="text-sm text-gray-600 mb-4">
                    Can understand the main points of clear texts on familiar
                    topics
                </p>

                <div className="space-y-2 mb-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <div className="bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded">
                                B1
                            </div>
                            <span className="text-sm">Listening</span>
                        </div>
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <div className="bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded">
                                B1
                            </div>
                            <span className="text-sm">Speaking</span>
                        </div>
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <div className="bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded">
                                B1
                            </div>
                            <span className="text-sm">Reading</span>
                        </div>
                    </div>
                </div>

                <p className="text-xs text-gray-500">
                    Scores are determined based on assessments conducted in
                    accordance with the CEFR framework.
                </p>

                <div className="flex items-center gap-1 mt-3 text-xs text-gray-500">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                        ></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>Certified on 22 Jan 2025</span>
                </div>
            </div>
        </div>
    )
}
